
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nfts/collections/[collectionAddress]",
      function () {
        return require("private-next-pages/nfts/collections/[collectionAddress].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nfts/collections/[collectionAddress]"])
      });
    }
  